BoostOTP.AjaxCart.prototype.isRender = function() { return false; }

// Prevent call cart.js after adding a product
BoostOTP.AjaxCart.prototype.getCart = function(isOpenCart) { }

// Customize Success add to Cart method
var onSuccessAddToCart = BoostOTP.AjaxCart.prototype.onSucess;

BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel) {
  onSuccessAddToCart.call(this, data, $addingLabel, $errorLabel);

  // Call theme function
  //document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  //document.dispatchEvent(new CustomEvent('cart:open'));
  
  boostRefreshCart();
}    